import type { ReactNode } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type { AlertProps } from '@mui/material';
import { Alert } from '@mui/material';

export type ReviewStatusAlertProps = {
  children?: ReactNode;
  alertProps?: AlertProps;
};

/**
 * ReviewStatusAlert component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {ReviewStatusAlertProps} reviewStatusAlertProps - The props for the ReviewStatusAlert component
 * @returns {ReactElement} The ReviewStatusAlert component
 */
export const ReviewStatusAlert = ({
  children,
  alertProps,
}: ReviewStatusAlertProps) => {
  return (
    <Alert
      icon={<InfoOutlinedIcon />}
      variant="standard"
      severity="warning"
      {...alertProps}
    >
      {children}
    </Alert>
  );
};
